export default __webpack_public_path__ + "static/media/location-pin.04d4ab1d.svg";